/**
 * If the param strVal is a string, then remove hidden characters and trim it.
 * Otherwise, return the parameter unchanged.
 * Hidden characters are defined as non-printable ASCII characters (0–31 and 127),
 * and other characters that are not commonly visible.
 * @name removeHiddenChars
 * @param {string} strVar - The input string to sanitize.
 * @return {string} - The sanitized string with hidden characters removed.
 */
/* eslint-disable */
export const removeHiddenChars = (strVar) => {
    // Regular expression to match hidden characters
    const hiddenCharRegex =
        /[\x00-\x08\x0B-\x1F\x7F-\x9F\u00A0\u00AD\u200B-\u200F\u2028\u2029\u205F\u2060-\u2063\uFEFF\u180E]/g;
    if (typeof strVar === "string") {
        return strVar.replace(hiddenCharRegex, "").trim();
    }

    return strVar;
};
/* eslint-enable */
